<template>
  <v-main>
    <v-container fluid>
      <v-row justify="center" class="md-12">
        <v-dialog v-model="dialogVisible" :persistent="persistent" max-width="500">
          <v-card>
            <v-card-title class="headline">
              <v-row justify="space-between">
                {{ dialogTitle }}
              </v-row>
            </v-card-title>
            <template v-if="!dialogText">
              <slot name="body" />
            </template>
            <template v-else>
              <v-card-text>
                {{ dialogText }}
              </v-card-text>
            </template>
            <v-card-actions>
              <v-spacer />
              <slot name="footer" />
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </v-container>
  </v-main>
</template>
<script>
  export default {
    name: "BaseDialog",
    props: {
      dialogTitle: {
        type: String,
        default: 'Заголовок'
      },
      dialogText: {
        type: String,
        default:  null
      },
      visible: {
      type: Boolean,
      default: false
    },
      persistent: {
      type: Boolean,
      default: false
    }
    },
    data: () => ({
      dialog: false,
      dialogVisible: this.visible
    }),
    watch: {
    visible (newValue) {
      this.dialogVisible = newValue
    },
    dialogVisible (newValue) {
      this.$emit('update:visible', newValue)
    }
  }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/BaseDialog.vue